var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalMall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4f2b12",
    d: "M218.461-120q-23.91 0-41.186-17.275Q160-154.551 160-178.461v-446.155q0-23.91 17.275-41.186 17.276-17.275 41.186-17.275h104.616q0-65.564 45.038-111.244Q413.154-840 478.718-840q66.101 0 112.153 45.525 46.052 45.526 46.052 111.398h104.616q23.91 0 41.186 17.275Q800-648.526 800-624.616v446.155q0 23.91-17.275 41.186Q765.449-120 741.539-120H218.461Zm0-33.846h523.078q9.231 0 16.923-7.692 7.692-7.692 7.692-16.923v-446.155q0-9.231-7.692-16.923-7.692-7.692-16.923-7.692H218.461q-9.231 0-16.923 7.692-7.692 7.692-7.692 16.923v446.155q0 9.231 7.692 16.923 7.692 7.692 16.923 7.692ZM480-449.231q65.718 0 112.218-46.5t46.5-112.218h-33.846q0 51.795-36.855 88.333-36.856 36.539-88.077 36.539-51.222 0-87.761-36.539-36.538-36.538-36.538-88.333h-33.846q0 65.718 46.243 112.218 46.244 46.5 111.962 46.5ZM356.923-683.077h246.154q0-51.282-35.897-87.18-35.898-35.897-87.18-35.897-51.282 0-87.18 35.897-35.897 35.898-35.897 87.18ZM193.846-153.846v-495.385 495.385Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalMall);
export default __webpack_public_path__ + "static/media/local_mall.186ef1a16ad62b471c3918b2994b981b.svg";
export { ForwardRef as ReactComponent };